import { OnInit, Injector, Component, ChangeDetectionStrategy } from '@angular/core';
import { HttpService } from '../services/http/http-service.service';
import { NzMessageService, NzModalService } from 'ng-zorro-antd';
import { SFormService } from '../components/s-form/s-form.service';
import { BaseService } from '../services/base/base.service';
import { STableService } from '../components/s-table/s-table.service';
import { CommonService } from '../services/common/common.service';
import { merge } from 'lodash';
import { forkJoin, of, iif, interval } from 'rxjs';
import { tap, mapTo, startWith, takeUntil, takeWhile, take, takeLast } from 'rxjs/operators';

export class MultipleComponent implements OnInit {
    baseService: BaseService;
    httpService: HttpService;
    message: NzMessageService;
    formService: SFormService;
    modal: NzModalService;
    tableService: STableService;
    commonService: CommonService;
    constructor(
        injector: Injector
    ) {
        this.getInjector(injector);
    }
    componentConfigList: any[];
    subParams: any = {};
    formLoading = true;
    detailId: string;
    validate = false;
    submitLoading = false;
    projectCode: string;
    qrInfo = '';
    locationsCacheData = [];
    detailData: any;
    coordinateValue: Array<Array<number>>;
    isUpdateMem = false;
    ngOnInit(): void {
    }

    /**
     * 从注入器中获取对象
     * @param injector 注入器
     */
    getInjector(injector) {
        this.httpService = injector.get(HttpService);
        this.message = injector.get(NzMessageService);
        this.baseService = injector.get(BaseService);
        this.formService = injector.get(SFormService);
        this.modal = injector.get(NzModalService);
        this.tableService = injector.get(STableService);
        this.commonService = injector.get(CommonService);
    }

    /**
     * 获取所有表单mapper数据，并赋值
     */
    initConfigDataOfMapper(mapperUrl?) {
        if (mapperUrl) {
            this.getMapperFormConfig(mapperUrl);
        } else {
            this.initStaticFormConfig();
        }
    }

    /**
     *  初始化所有静态表单配置
     */
    initStaticFormConfig() {
        const componentConfigList = this.componentConfigList;
        componentConfigList.forEach((itemConfig) => {
            itemConfig = this.baseService.initStaticFormData(itemConfig);
            itemConfig.formConfig.show = true;
        });
    }
    getMapperFormConfig(mapperUrl) {
        const componentConfigList = this.componentConfigList;
        forkJoin(componentConfigList.map((configItem) => {
            const formConfig = configItem.formConfig;
            if (formConfig.formMapperCode) {
                let tempStaticConfig = null;
                const config = {
                    url: mapperUrl,
                    params: { mapperCode: formConfig.formMapperCode, code: formConfig.formMapperCode }
                };
                if (formConfig.staticConfig) {
                    tempStaticConfig = formConfig.staticConfig;
                }

                return this.baseService.initFormData(config, tempStaticConfig).pipe(
                    tap(res => {
                        formConfig.items = res;
                        configItem.formConfig = { ...formConfig };
                        setTimeout(() => {
                            this.formLoading = false;
                        }, 200);
                    }),
                    mapTo(formConfig)
                );
            } else {
                return of('');
            }
        })).subscribe(res => {
            this.renderFormAfter();
        }, (err) => {
            this.message.error(err.message);
        });
    }

    renderFormAfter() { }

    /**
     *
     * @param componentConfig 为弹框新增表单/表格/上传组件
     */
    addComponentConfig(componentConfig) {
        this.componentConfigList.push(componentConfig);
    }
    /**
     * 返回所有的组件
     */
    getComponentConfigList(id) {
        this.componentConfigList.forEach((item) => {
            if (item.fileConfig) {
                item.fileConfig.showPreviewIcon = true;
                item.fileConfig.showRemoveIcon = true;
                if (id) {
                    item.fileConfig.showPreviewIcon = true;
                    item.fileConfig.showRemoveIcon = false;
                }
            }
            if (item.tableConfig && this.detailId) {
                item.tableConfig.tableData = [];
            }
        });
        return this.componentConfigList;
    }


    /**
     * 获取所有需要提交的参数
     */
    getSubParams() {
        return this.subParams;
    }
    /**
     * 设置所有需要提交的参数
     */
    setSubParams() {
        this.validate = true;
        this.componentConfigList.forEach((item) => {
            if (
                item.isForm && item.formConfig.formGroup && !item.tableConfig) {  // 表单信息
                this.reRenderValues(item);
            }
            if (item.locationConfig) {  // 位置信息
                const locatinParams = (this.coordinateValue || []).map(([longitude, latitude]) => ({ longitude, latitude }));
                if (this.validate && locatinParams.length === 0) {
                    this.message.error('请绘制工程位置');
                    return;
                }
                const nameArr = item.name.split(',');
                this.subParams[nameArr[0]] = locatinParams;
            }
            if (item.fileConfig && item.fileConfig.fileType === 'img' && !item.tableConfig) {  // 工程面貌
                const features = [];
                item.fileConfig.fileList.forEach((f) => {
                    features.push({ fileExtension: f.fileExtension, fileId: f.fileId, fileName: f.fileName });
                });
                const nameArr = item.name.split(',');
                this.subParams[nameArr[0]] = features;
            }
            if (item.fileConfig && item.fileConfig.fileType === 'file' && !item.tableConfig) {  // 水位-库容-面积
                const fileList = [];
                item.fileConfig.fileList.forEach((f) => {
                    fileList.push({ fileExtension: f.fileExtension, fileId: f.fileId, fileName: f.fileName });
                });
                this.subParams[item.name] = fileList;
            }
        });
    }
    /**
     * 弹框所有数据提交之前
     */
    submitBefore() { }

    reRenderValues(item) {
        if (!this.formService.validateForm(item.formConfig.formGroup)) {
            this.validate = false;
        } else {
            const value = item.formConfig.formGroup.value;
            for (const key in value) {
                if (key.indexOf('Pipe') !== -1) {
                    const result = key.split('Pipe')[0];
                    value[result] = value[key];
                }
            }
            if (item.name === 'baseInfo') {
                merge(this.subParams, value || {});
            } else {
                this.subParams[item.name] = value || {};
            }
        }
    }

    /**
     *
     * @param url 提交弹框里所有数据
     */
    submit(url) {
        this.setSubParams();
        this.submitBefore();
        this.submitLoading = true;
        if (!this.validate) {
            this.message.error('表单校验不通过');
            this.submitLoading = false;
            return;
        }
        if (!this.validate || !(this.coordinateValue && this.coordinateValue.length)) {
            this.submitLoading = false;
            return;
        }
        this.httpService.httpPost(url, this.subParams).subscribe(res => {
            this.submitLoading = false;
            if (res.code === 1) {
                this.message.success('保存成功');
                this.submitAfter();
            }
        }, _ => {
            this.submitLoading = false;
        });
    }

    // 数据提交之后
    // 清空弹框数据
    submitAfter() {
        this.componentConfigList.forEach((item) => {
            if (item.isForm && item.formConfig.formGroup) {
                this.formService.resetForm(item.formConfig.formGroup);
            }
            if (item.fileConfig) {
                item.fileConfig.fileList = [];
                item.fileConfig.showBtn = true;
            }
            if (item.locationConfig) {
                this.coordinateValue = [];
            }
            if (item.tableConfig) {
                item.tableConfig.tableData = [];
            }
        });
        this.clearMap();
        this.resetOthersComponent();
    }

    /**
     * 清除地图
     */
    clearMap() { }

    /**
     * 重置所有表单
     */
    reset() {
        this.submitLoading = false;
        this.componentConfigList.forEach((config) => {
            if (config.isForm && config.formConfig.formGroup) {
                config.formConfig.formGroup = this.formService.resetForm(config.formConfig.formGroup);
                this.validate = false;
            }
            if (config.tableConfig) {
                config.tableConfig.tableData = [];
            }
            if (config.fileConfig) {
                config.fileConfig.fileList = [];
            }
        });
        this.resetOthersComponent();
        this.clearMap();
    }


    /**
     * 重置其他组件
     */
    resetOthersComponent() { }

    /**
     * 重置单个表单,恢复表单默认值
     */
    singleReset(componentConfig) {
        // 重置表单
        if (componentConfig.formConfig.formGroup) {
            componentConfig.formConfig.formGroup =
                this.formService.resetForm(componentConfig.formConfig.formGroup, componentConfig.formConfig.values);
        }
        if (componentConfig.fileConfig) {
            componentConfig.fileConfig.fileList = JSON.parse(JSON.stringify(componentConfig.fileConfig.cacheData));
        }
    }

    /**
     * 提交单个表单
     */
    singleSubmit(componentConfig) {
        if (componentConfig.isForm && componentConfig.formConfig.formGroup) {
            this.submitSingleForm(componentConfig);
        }
        if (componentConfig.locationConfig) {  // 位置信息
            this.submitLocations(componentConfig);
        }
        if (componentConfig.fileConfig && !componentConfig.tableConfig) {  // 工程面貌、水位-库容-曲线
            this.submitFile(componentConfig);
        } else {
            this.submitOthers(componentConfig);
        }
        // if (componentConfig.tableConfig) {  // 提交表格数据（工程大事记）
        //     this.subSingleTableConfig(componentConfig);
        // }
    }

    /**
     * 提交其他数据
     */
    submitOthers(componentConfig) { }

    singleSubmitAfter(componentConfig, data) { }
    singleSubmitBefore(componentConfig) {}
    submitSingleForm(componentConfig) {
        this.subParams = {
            projectCode: this.projectCode,
            projectId: this.detailId,
        };
        const submitType = componentConfig.formConfig.submitType;
        if (!this.formService.validateForm(componentConfig.formConfig.formGroup)) { return; }
        const value = componentConfig.formConfig.formGroup.value;
        for (const key in value) {
            if (key.indexOf('Pipe') !== -1) {
                const result = key.split('Pipe')[0];
                value[result] = value[key];
            }
        }
        if (componentConfig.name === 'baseInfo') {
            this.subParams = Object.assign(componentConfig.formConfig.values, value);
        } else {
            // this.subParams.projectCode = this.projectCode;
            let key = componentConfig.name;
            if (componentConfig.editKey) {
                key = componentConfig.editKey;
            }
            this.subParams[key] =
                Object.assign(componentConfig.formConfig.values, value);
        }
        // 提交表单前回调
        this.singleSubmitBefore(componentConfig);
        switch (submitType) {
            case 'post':
                this.httpService.httpPost(componentConfig.formConfig.submitUrl, this.subParams).subscribe(res => {
                    if (res.code === 1) {
                        this.message.success('保存成功');
                        this.submitFormAfter(componentConfig, res.data);
                        this.singleSubmitAfter(componentConfig, res.data);
                        this.renderForm(res.data);
                    }
                });
                break;
            case 'put':
                this.httpService.httpUpdate(componentConfig.formConfig.submitUrl, this.subParams).subscribe(res => {
                    if (res.code === 1) {
                        this.message.success('保存成功');
                        this.submitFormAfter(componentConfig, res.data);
                        this.singleSubmitAfter(componentConfig, res.data);
                        this.renderForm(res.data);
                    }
                });
                break;
            default:
                break;
        }
    }
    renderForm(data) { }

    submitFormAfter(componentConfig, data) {
        const config = componentConfig.formConfig;
        for (const key in config.items) {
            if (config.items.hasOwnProperty(key)) {
                const element = config.items[key];
                element.isEdit = false;
            }
        }
        componentConfig.formConfig.isEdit = false;
        if (data === null || !data) {
            return;
        }
        this.formService.resetForm(componentConfig.formConfig.formGroup, data);
        if (componentConfig.name !== 'baseInfo') {
            this.subParams.projectCode = this.projectCode;
            this.subParams.projectId = this.detailId;
            componentConfig.formConfig.values = data;
        } else {
            merge(this.subParams, componentConfig.formConfig.formGroup.value);
            merge(this.subParams, data);
        }
    }

    submitFile(componentConfig) {
        const url = componentConfig.formConfig.submitUrl;
        // componentConfig.fileConfig.fileList.forEach((file) => {
        //     file.projectCode = this.projectCode;
        // });
        const params = {
            projectCode: this.projectCode,
            projectId: this.detailId,
        };
        const fileList = [];
        componentConfig.fileConfig.fileList.forEach((f) => {
            const temp = {
                fileExtension: f.fileExtension, fileId: f.fileId, fileName: f.fileName,
                version: f.version, projectCode: f.projectCode, name: f.fileName
            };
            fileList.push(temp);
        });
        if (componentConfig.fileConfig.fileType === 'img') {
            const nameArr = componentConfig.name.split(',');
            params[nameArr[1]] = fileList;
        } else if (componentConfig.fileConfig.fileType === 'file') {
            let key = componentConfig.name;
            if (componentConfig.editKey) {
                key = componentConfig.editKey;
            }
            params[key] = fileList;
        }
        const copyData = JSON.parse(JSON.stringify(componentConfig.fileConfig.fileList));
        this.httpService.httpPost(url, params).subscribe(res => {
            if (res.code === 1) {
                this.message.success('保存成功');
                // componentConfig.fileConfig.cacheData = componentConfig.fileConfig.fileList;
                this.submitFileAfter(componentConfig, res.data);
            }
        });
    }

    submitFileAfter(componentConfig, data) {
        componentConfig.formConfig.isEdit = false;
        componentConfig.fileConfig.showBtn = false;
        if (!data || data.length === 0) {
            return;
        }
        data.forEach((d) => {
            d.url = `${componentConfig.fileConfig.fileBaseUrl}/${d.fileId}`;
        });
        componentConfig.fileConfig.cacheData = data;
        componentConfig.fileConfig.fileList = data;
        componentConfig.fileConfig.showRemoveIcon = false;

        componentConfig.fileConfig = JSON.parse(JSON.stringify(componentConfig.fileConfig));
    }


    subSingleTableConfig(componentConfig) {
        this.subParams[componentConfig.name] = componentConfig.tableConfig.tableData;
        this.httpService.httpPost(componentConfig.formConfig.submitUrl, this.subParams).subscribe(res => {
            if (res.code === 1) {
                this.message.success('保存成功');
                this.subSingleTableConfigAfter(res.data);
                componentConfig.tableConfig.tableData = res.data;
            }
        });
    }

    subSingleTableConfigAfter(data) {

    }

    submitLocations(componentConfig) {
        const params = {
            projectCode: this.projectCode,
            projectId: this.detailId,
        };
        const nameArr = componentConfig.name.split(',');
        if (!(this.coordinateValue && this.coordinateValue.length)) {
            this.message.error('请绘制工程位置');
            return;
        }
        const locations = this.coordinateValue.map(([longitude, latitude]) => ({ longitude, latitude }));
        params[nameArr[1]] = locations;
        this.httpService.httpPost(componentConfig.formConfig.submitUrl, params).subscribe(res => {
            if (res.code === 1) {
                componentConfig.formConfig.isEdit = false;
                this.message.success('保存成功');
            }
        });
    }

    /**
     * 根据id获取单条数据详情
     * @param id 单条数据id
     * @param url 获取单条数据的接口地址
     */
    getDetailById(id, url) {
        this.detailId = id;
        const detaiUrl = `${url}/${id}`;
        this.httpService.httpGet(detaiUrl).subscribe(res => {
            if (res.code === 1) {
                if (!res.data) { return; }
                this.setDetailDataToFormConfig(res.data);
                this.getDetailAfter(res.data);
            }
        });
    }
    /**
     * 设置表单详情数据
     */
    setDetailDataToFormConfig(data) {
        if (data.qr && data.qr.qrInfo) {
            this.qrInfo = data.qr.qrInfo;
        }
        this.componentConfigList.forEach((config) => {
            if (config.isForm && !config.tableConfig) {  // 为纯表单赋值
                this.initFormData(data, config);
            }
            if (config.locationConfig) {  // 位置信息赋值
                const name = config.name.split(',')[0];
                this.initLocationsFormData(data[name], config);
            }
            if (config.fileConfig && !config.tableConfig && config.fileConfig.fileType === 'img') {  // 工程面貌赋值
                const name = config.name.split(',')[0];
                this.initFeaturesFormData(data[name], config);
            }
            if (config.fileConfig && config.fileConfig.fileType === 'file') {  // 文件赋值
                this.initFileFormData(data, config);
            }
            // if (config.tableConfig) {  // 工程大事记赋值
            //     this.initTableConfigData(data, config);
            // }
        });
    }
    getDetailAfter(data) {
    }



    getDetailDatas(data) {
        return data;
    }


    /**
     * 获取工程代码
     */
    getProjectCode(code) {
        this.projectCode = code;
    }

    /**
     *
     * @param id 根据是否有id判断当前是新增还是编辑，设置表单项状态
     */
    resetComponentStatus(id) {
        id ? this.showAllComponent() : this.showFirstComponent();
        this.showOrHiddenUploadBtn(id);
    }

    /**
     * 编辑时，显示所有表单项，并且时编辑状态，不可编辑
     */
    showAllComponent() {
        this.componentConfigList.forEach((config) => {
            config.formConfig.show = true;
            config.formConfig.update = true;
            config.formConfig.add = false;
            config.formConfig.isEdit = false;
        });
    }

    showOrHiddenUploadBtn(id) {
        this.componentConfigList.forEach((config) => {
            if (config.fileConfig) {
                id ? config.fileConfig.showBtn = false : config.fileConfig.showBtn = true;
            }
        });
    }

    /**
     * 新增时，显示第一个表单项，并且时添加状态，可编辑,且清空文件列表
     */
    showFirstComponent() {
        this.componentConfigList.forEach((config, index) => {
            index === 0 ? config.formConfig.show = true : config.formConfig.show = false;
            config.formConfig.update = false;
            config.formConfig.add = true;
            config.formConfig.isEdit = true;
            if (config.fileConfig) {
                config.fileConfig.fileList = [];
            }
        });
    }

    /**
     * 将表单项设置为可编辑状态
     * @param config 表单项
     */
    setComponentToEdit(componentConfig, index) {
        const config = componentConfig.formConfig;
        for (const key in config.items) {
            if (config.items.hasOwnProperty(key)) {
                const element = config.items[key];
                element.isEdit = true;
            }
        }
        config.isEdit = true;
        config.show = true;
        if (componentConfig.fileConfig) {
            const copy = JSON.parse(JSON.stringify(componentConfig));
            copy.fileConfig.showBtn = true;
            if (copy.fileConfig.fileList.length === copy.fileConfig.max) {
                copy.fileConfig.showBtn = false;
            }
            copy.fileConfig.showPreviewIcon = true;
            copy.fileConfig.showRemoveIcon = true;
            componentConfig = copy;
        }
        if (this.componentConfigList[index].name === componentConfig.name) {
            this.componentConfigList[index] = componentConfig;
        }
    }
    /**
     * 获取详情数据后，为表单基本信息赋值
     */
    initFormData(data, config) {
        const timer = setInterval(() => {
            if (config.formConfig.formGroup) {
                const formatData = this.resetValueForInt(data, config);
                this.getGroup(formatData, config);
                clearInterval(timer);
            } else {
            }
        }, 300);
    }

    resetValueForInt(data, config) {
        const items = config.formConfig.items;
        for (const key in items) {
            if (items.hasOwnProperty(key)) {
                if (items[key].n && items[key].length === 1) {
                    data[key] = parseInt(data[key], 0);
                }
            }
        }
        return data;
    }


    getGroup(data, config) {
        const items = config.formConfig.items;
        // for (const key in items) {
        //     if (items.hasOwnProperty(key)) {
        //         const temp = items[key];
        //         if (temp.ui.unEdit && temp.ui.unEdit !== null) {
        //             temp.ui.unEdit = JSON.parse(temp.ui.unEdit);
        //         } else {
        //             temp.ui.unEdit = false;
        //         }
        //     }
        // }
        if (config.name === 'baseInfo') {
            config.formConfig.values = data;
            this.formService.resetForm(config.formConfig.formGroup, data);

        } else {
            config.formConfig.values = data[config.name];
            this.formService.resetForm(config.formConfig.formGroup, data[config.name]);
        }
        for (const key in config.formConfig.items) {
            if (data.hasOwnProperty(key) && config.formConfig.items[key].ui.type === 'select') {
                config.formConfig.items[key].value = data[key];
            }
        }
        // this.setFormValue(data, config);
    }
    setFormValue(data, config) {
        const items = config.formConfig.items;
        for (const key in items) {
            if (items.hasOwnProperty(key)) {
                items[key].value = data[key];
            }
        }
    }


    /**
     * 获取详情数据后，为表单gis赋值
     */
    initLocationsFormData(locations, config) {
        this.coordinateValue = locations.map(({ longitude, latitude }) => ([longitude, latitude]));
        this.locationsCacheData = locations.map(({ longitude, latitude }) => ([longitude, latitude]));
    }

    /**
     * 缓存gis的详情数据
     */
    getLocationCacheData() {
        return this.locationsCacheData;
    }


    initFileFormData(data, config) {
        if (!data[config.name]) {
            return;
        }
        data[config.name].forEach((item) => {
            item['name'] = item.fileName;
            item.url = `${config.fileConfig.fileBaseUrl}/${item.fileId}`;
        });
        config.fileConfig.fileList = data[config.name];
        config.fileConfig.showRemoveIcon = false;
        config.fileConfig.showBtn = false;
        config.fileConfig.cacheData = JSON.parse(JSON.stringify(data[config.name]));
    }

    /**
     * 渲染表格数据
     */
    initTableConfigData(data, config) {
        if (!data[config.name]) {
            return;
        }
        const list = data[config.name];
        list.forEach(f => {
            if (f.pictureList && f.pictureList.length > 0) {
                const pictureList = f.pictureList;
                pictureList.forEach((p) => {
                    p['name'] = p.fileName;
                    p['url'] = `${config.fileBaseUrl}/${p.fileId}`;
                });
            }
        });
        config.tableConfig.tableData = list;
        config.tableConfig = this.tableService.refreshTabl(config.tableConfig);
    }

    /**
     * 获取详情数据后，为表单工程面貌赋值
     * @param features 工程面貌项name
     * @param config 工程面貌config
     */
    initFeaturesFormData(features, config) {
        if (!features || !features.length) { return; }
        const baseUrl = config.fileConfig.fileBaseUrl;
        features.forEach((f) => {
            f.url = `${baseUrl}/${f.fileId}`;
        });
        config.fileConfig.fileList = features;
        config.fileConfig.showBtn = false;
        config.fileConfig.cacheData = JSON.parse(JSON.stringify(features));
    }

    /**
     * 删除表格行数据（前端删除）
     * @param componentConfig 带表单、上传和表格的清空，表格当前项
     * @param index 当前表格rowIndex
     */
    removeRowData(componentConfig, index) {
        componentConfig.tableConfig.tableData.splice(index, 1);
        componentConfig.tableConfig = this.tableService.refreshTabl(componentConfig.tableConfig);
    }

    /**
     * 删除当前表格行数据
     */
    showDeleteModal(tableCOnfig, index) {
        this.modal.confirm({
            nzTitle: '提示?',
            nzContent: '<b style="color: red;">确定要删除选中数据吗</b>',
            nzOkText: '确定',
            nzOkType: 'danger',
            nzOnOk: () => this.removeRowData(tableCOnfig, index),
            nzCancelText: '取消',
        });
    }

    /**
     * 添加表格行数据
     * @param formConfig 表单对象
     */
    insertRowData(componentConfig) {
        if (this.formService.validateForm(componentConfig.formConfig.formGroup)) {
            componentConfig.tableConfig.tableData.push(componentConfig.formConfig.formGroup.value);
            componentConfig.tableConfig = this.tableService.refreshTabl(componentConfig.tableConfig);
        }
    }

    /**
     * 查看大事记图片
     */
    showImgs(rowData) {

    }

    scrollToElement(anchorConfig) {
        const element = document.querySelector('#' + anchorConfig.href);
        element.scrollIntoView(true);
        this.componentConfigList[anchorConfig.index].formConfig.show = true;
    }

    downLoadByGet(url) {
        this.commonService.downLoad(url, 'GET');
        // fetch(url, {
        //     method: 'GET',
        //     headers: new Headers({
        //         'Content-Type': 'application/json;charset=UTF-8',
        //     })
        // }).then(response => {
        //     if (response['code'] && response['code'] === 2) {
        //         this.message.error(response['message']);
        //         return;
        //     }
        //     response.blob().then(blob => {
        //         const disposition = response.headers.get('Content-Disposition');
        //         const fileName = disposition.split(';')[1].split('=')[1];
        //         const blobUrl = window.URL.createObjectURL(blob);
        //         const aElement = document.createElement('a');
        //         aElement.download = decodeURI(fileName);
        //         document.body.appendChild(aElement);
        //         aElement.style.display = 'none';
        //         aElement.href = blobUrl;
        //         aElement.click();
        //         document.body.removeChild(aElement);
        //     });
        // });
    }

    downLoadByPost(url, params?) {
        this.commonService.downLoad(url, 'POST', params);
        // fetch(url, {
        //     method: 'POST',
        //     body: JSON.stringify(params) || '',
        //     headers: new Headers({
        //         'Content-Type': 'application/json;charset=UTF-8',
        //     })
        // }).then(response => {
        //     if (response['code'] && response['code'] === 2) {
        //         this.message.error(response['message']);
        //         return;
        //     }
        //     response.blob().then(blob => {
        //         const disposition = response.headers.get('Content-Disposition');
        //         const fileName = disposition.split(';')[1].split('=')[1];
        //         const blobUrl = window.URL.createObjectURL(blob);
        //         const aElement = document.createElement('a');
        //         aElement.download = decodeURI(fileName);
        //         document.body.appendChild(aElement);
        //         aElement.style.display = 'none';
        //         aElement.href = blobUrl;
        //         aElement.click();
        //         document.body.removeChild(aElement);
        //     });
        // });
    }
}
